export default __webpack_public_path__ + "static/wolfpack-d6481c0efe5fdb45536134bb492210a9.png";